function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 15,
  height: 15,
  rx: 0.5,
  stroke: "currentColor"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.7273 4C10.4762 4 10.2727 4.19898 10.2727 4.44444V11.5556C10.2727 11.801 10.4762 12 10.7273 12H12.5455C12.7965 12 13 11.801 13 11.5556V4.44444C13 4.19898 12.7965 4 12.5455 4H10.7273ZM12.0909 11.1111H11.1818V4.88889H12.0909V11.1111Z",
  fill: "currentColor"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6.63636 6.22222C6.63636 5.97676 6.83987 5.77778 7.09091 5.77778H8.90909C9.16013 5.77778 9.36364 5.97676 9.36364 6.22222V11.5556C9.36364 11.801 9.16013 12 8.90909 12H7.09091C6.83987 12 6.63636 11.801 6.63636 11.5556V6.22222ZM7.54545 6.66667V11.1111H8.45455V6.66667H7.54545Z",
  fill: "currentColor"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3 8C3 7.75454 3.20351 7.55556 3.45455 7.55556H5.27273C5.52377 7.55556 5.72727 7.75454 5.72727 8V11.5556C5.72727 11.801 5.52377 12 5.27273 12H3.45455C3.20351 12 3 11.801 3 11.5556V8ZM3.90909 8.44444V11.1111H4.81818V8.44444H3.90909Z",
  fill: "currentColor"
});

var SvgChartsSquare = function SvgChartsSquare(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgChartsSquare, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/charts-square.38272f96.svg";
export { ForwardRef as ReactComponent };